import React from 'react'
import { useTranslation } from 'react-i18next';

import { GOOGLE_PLAY_URL } from '../../constants';

import QRCode from '../../images/google-play-QRcode.png';
import ButtonGooglePlay from '../../images/btn-google-play-badge.png';
import ImgPlayMobile from '../../images/google-play-mobile.png';

import './download.scss';

const Download = () => {
    const { t } = useTranslation();

    return (
        <div id='download' className='row'>
            <div className="wrapper">
                 <div className="title">{t('titleDownload_vg')}</div>
                 <div className="main-content">
                     <div className="left">
                        <div className="QR-and-desc">
                            <img alt='QRcode' src={QRCode} className='qr-code'/>
                            <span className='desc'>{t('contentPlay_vg')}</span>
                        </div>                    
                        <a href={GOOGLE_PLAY_URL} target='_blank' rel="noopener noreferrer">
                            <img src={ButtonGooglePlay} alt="button-google-play"/>
                        </a>
                    </div>
                    <div className="right">
                        <img src={ImgPlayMobile} alt="google-play" className="play-mobile"s/>
                    </div>   
                 </div>                              
            </div>
           
        </div>
    )
}

export default Download;
